module.exports = __webpack_public_path__ + "static/img/flex-people.3aac35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/confirmOrder/flex-people.png
// module id = 898
// module chunks = 2